import { useEffect, useRef, useState } from 'react'

export const useMultipleInView = (options: IntersectionObserverInit) => {
  const refs = useRef<(HTMLElement | null)[]>([])
  const [inViewMap, setInViewMap] = useState<Record<number, boolean>>({})

  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      setInViewMap(prevState => {
        const newState = { ...prevState }
        entries.forEach(entry => {
          const index = refs.current.findIndex(el => el === entry.target)
          if (index !== -1 && entry.isIntersecting) {
            newState[index] = true
          }
        })

        return newState
      })
    }, options)

    refs.current.forEach(ref => {
      if (ref) observer.observe(ref)
    })

    return () => observer.disconnect()
  }, [])

  const setRef = (index: number) => (ref: HTMLElement | null) => {
    if (ref && refs.current[index] !== ref) {
      refs.current[index] = ref
    }
  }

  return { inViewMap, setRef }
}
